// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Destructured Payload
// MODIFIED DATE : 12-08-2025

/* eslint-disable no-debugger */
import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
	addIndividualLoanProposalFailure,
	addIndividualLoanProposalListResponseChanged,
	addIndividualLoanProposalSuccess,
	searchMemberLoanProposalFailure,
	searchMemberLoanProposalListResponseChanged,
	searchMemberLoanProposalSuccess,
	updateIndividualLoanProposalFailure,
	updateIndividualLoanProposalListResponseChanged,
	updateIndividualLoanProposalSuccess,
} from './individual-loan-proposal.action';
import IndividualLoanActionTypes from './individual-loan-proposal.types';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	addIndividualLoanProposal,
	fetchSearchMemberLoanProposalList,
	updateIndividualLoanProposal,
} from './individual-loan-proposal.service';

/**   ******************* ADD INDIVIDUAL LOAN PROPOSAL *************** */
export function* addindividualLoanProposal({ payload }: any) {
	try {
		const {
			areaID,
			branchID,
			loanProposalDate,
			totalLoanAmount,
			loanStartDate,
			loanEndDate,
			meetUpLocation,
			memberMeetupLat,
			memberMeetupLong,
			meetUpTime,
			groupID,
			groupProductID,
			groupMemberLeadID,
			groupOfficerID,
			companyID,
			createdUser,
			productInvestorDetails,
			loanIndexType,
			funderName,
			loanIndexGroupMemberID,
			memberID,
			loanType,
			amountReceived,
			amountOutStanding,
			numberOfDueLeft,
			purposeOfLoanID,
			areaUID,
			centerUID,
			groupUID,
			databaseName,
			isViaNach,
			thriftID,
			thrift2,
			loanschedule,
			generalCompanyID,
			collectionType,
			isRangeProduct,
			principalAmount,
			interestAmount,
			interestPercentage,
			numberOfInstalment,
			preLoanProposalID,
			paidAmount,
			thriftID2,
		} = payload;
		const key = 'AddPersonalLoanIndexDataKey';
		debugger;
		const jsonData = {
			AreaID: areaID,
			BranchID: branchID,
			LoanProposalDate: loanProposalDate,
			TotalLoanAmount: totalLoanAmount,
			LoanStartDate: loanStartDate,
			LoanEndDate: loanEndDate,
			MeetUpLocation: meetUpLocation,
			MemberMeetupLat: memberMeetupLat,
			MemberMeetupLong: memberMeetupLong,
			MeetUpTime: meetUpTime,
			GroupID: groupID,
			GroupProductID: groupProductID,
			GroupMemberLeadID: groupMemberLeadID,
			GroupOfficerID: groupOfficerID,
			CompanyID: companyID,
			CreatedUser: createdUser,
			ProductInvestorDetails: productInvestorDetails,
			LoanIndexType: loanIndexType,
			FunderName: funderName,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			LoanType: loanType,
			AmountReceived: amountReceived !== '' && amountReceived != null ? Number(amountReceived) : 0,
			AmountOutStanding: amountOutStanding !== '' && amountOutStanding != null ? Number(amountOutStanding) : 0,
			NumberOfDueLeft: numberOfDueLeft !== '' ? parseInt(numberOfDueLeft) : 0,
			PurposeOfLoanID: purposeOfLoanID,
			AreaUID: areaUID,
			CenterUID: centerUID,
			GroupUID: groupUID,
			DatabaseName: databaseName,
			IsViaNach: isViaNach,
			thriftID: thriftID,
			thriftID2: thriftID2,
			thrift2: thrift2,
			Loanschedule: loanschedule,
			GeneralCompanyID: generalCompanyID,
			CollectionType: collectionType,
			IsRangeProduct: isRangeProduct,
			PrincipalAmount: principalAmount,
			ProductInterest: interestAmount,
			InterestPercentage: interestPercentage,
			NumberOfInstalment: numberOfInstalment,
			PreLoanProposalID: preLoanProposalID,
			PaidAmount: paidAmount,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(addIndividualLoanProposal, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addIndividualLoanProposalFailure(responseData.data));
		} else {
			yield put(addIndividualLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addIndividualLoanProposalFailure(error));
	}
}

export function* resetIndividualLoanLoanProposalResponse() {
	yield put(addIndividualLoanProposalListResponseChanged());
}

export function* onIndividualLoanLoanProposal() {
	yield takeLatest(
		IndividualLoanActionTypes.ADD_INDIVIDUAL_LOAN_PROPOSAL_START,
		addindividualLoanProposal,
	);
}

export function* onIndividualLoanLoanProposalResponseReset() {
	yield takeLatest(
		IndividualLoanActionTypes.ADD_INDIVIDUAL_LOAN_PROPOSAL_RESPONSE_RESET,
		resetIndividualLoanLoanProposalResponse,
	);
}
/** *********************  END ADD INDIVIDUAL LOAN PROPOSAL ******************** */

/** ******************* UPDATE INDIVIDUAL LOAN PROPOSAL START *************** */
export function* updateindividualLoanProposal({ payload }: any) {
	try {
		const {
			areaID,
			branchID,
			loanProposalDate,
			totalLoanAmount,
			loanStartDate,
			loanEndDate,
			meetUpLocation,
			memberMeetupLat,
			memberMeetupLong,
			meetUpTime,
			groupID,
			groupProductID,
			groupMemberLeadID,
			groupOfficerID,
			companyID,
			createdUser,
			productInvestorDetails,
			loanIndexType,
			funderName,
			loanIndexGroupMemberID,
			memberID,
			loanType,
			amountReceived,
			amountOutStanding,
			numberOfDueLeft,
			purposeOfLoanID,
			areaUID,
			centerUID,
			groupUID,
			databaseName,
			isViaNach,
			thriftID,
			thriftID2,
			loanschedule,
			generalCompanyID,
			collectionType,
			isRangeProduct,
			principalAmount,
			interestAmount,
			interestPercentage,
			numberOfInstalment,
			preLoanProposalID,
			paidAmount,
			loanIndexID,
			productTypeID,
		} = payload;
		const key = 'UpdatePersonalLoanIndexDataKey';
		const jsonData = {
			AreaID: areaID,
			BranchID: branchID,
			LoanProposalDate: loanProposalDate,
			TotalLoanAmount: totalLoanAmount,
			LoanStartDate: loanStartDate,
			LoanEndDate: loanEndDate,
			MeetUpLocation: meetUpLocation,
			MemberMeetupLat: memberMeetupLat,
			MemberMeetupLong: memberMeetupLong,
			MeetUpTime: meetUpTime,
			GroupID: groupID,
			GroupProductID: groupProductID,
			GroupMemberLeadID: groupMemberLeadID,
			GroupOfficerID: groupOfficerID,
			CompanyID: companyID,
			CreatedUser: createdUser,
			ProductInvestorDetails: productInvestorDetails,
			LoanIndexType: loanIndexType,
			FunderName: funderName,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			LoanType: loanType,
			AmountReceived: amountReceived !== '' && amountReceived != null ? Number(amountReceived) : 0,
			AmountOutStanding: amountOutStanding !== '' && amountOutStanding != null ? Number(amountOutStanding) : 0,
			NumberOfDueLeft: numberOfDueLeft !== '' && numberOfDueLeft != null ? numberOfDueLeft : 0,
			PurposeOfLoanID: purposeOfLoanID,
			AreaUID: areaUID,
			CenterUID: centerUID,
			GroupUID: groupUID,
			DatabaseName: databaseName,
			IsViaNach: isViaNach,
			thriftID: thriftID,
			thriftID2: thriftID2,
			Loanschedule: loanschedule,
			GeneralCompanyID: generalCompanyID,
			CollectionType: collectionType,
			IsRangeProduct: isRangeProduct,
			PrincipalAmount: principalAmount !== '' && principalAmount != null ? principalAmount : '',
			ProductInterest: interestAmount !== '' && interestAmount != null ? interestAmount : '',
			InterestPercentage: interestPercentage !== '' && interestPercentage != null ? interestPercentage : '',
			NumberOfInstalment: numberOfInstalment !== '' && numberOfInstalment != null ? numberOfInstalment : 0,
			PreLoanProposalID: preLoanProposalID,
			PaidAmount: paidAmount !== '' && paidAmount != null ? paidAmount : 0,
			LoanIndexID: loanIndexID,
			ProductTypeID: productTypeID,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(updateIndividualLoanProposal, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateIndividualLoanProposalFailure(responseData.data));
		} else {
			yield put(updateIndividualLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateIndividualLoanProposalFailure(error));
	}
}

export function* resetUpdateIndividualLoanLoanProposalResponse() {
	yield put(updateIndividualLoanProposalListResponseChanged());
}

export function* onUpdateIndividualLoanLoanProposal() {
	yield takeLatest(
		IndividualLoanActionTypes.UPDATE_INDIVIDUAL_LOAN_PROPOSAL_START,
		updateindividualLoanProposal,
	);
}

export function* onUpdateIndividualLoanLoanProposalResponseReset() {
	yield takeLatest(
		IndividualLoanActionTypes.UPDATE_INDIVIDUAL_LOAN_PROPOSAL_RESPONSE_RESET,
		resetUpdateIndividualLoanLoanProposalResponse,
	);
}
/** ********************* UPDATE INDIVIDUAL LOAN PROPOSAL END ******************** */

/** ***************** SEARCH MEMBER LOAN PROPOSAL START ***************** */
export function* individualLoanProposalGet({ payload }: any) {
	try {
		const {
			searchMemberValue,
			searchMemberType,
			companyID,
			userID,
			userRole,
			level,
			databaseName,
			isNoLoanCenter,
		} = payload;
		const key = 'getSearchMemberDetailsForPersonalLoanKey';
		const jsonData = {
			searchMemberValue: searchMemberValue,
			searchMemberType: searchMemberType,
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: level,
			DatabaseName: databaseName,
			IsNoLoanCenter: isNoLoanCenter,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchSearchMemberLoanProposalList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(searchMemberLoanProposalFailure(responseData.data));
		} else {
			yield put(searchMemberLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(searchMemberLoanProposalFailure(error));
	}
}

export function* resetSearchMemberLoanProposalResponse() {
	yield put(searchMemberLoanProposalListResponseChanged());
}

export function* onSearchMemberLoanProposal() {
	yield takeLatest(
		IndividualLoanActionTypes.SEARCH_MEMBER_LOAN_PROPOSAL_START,
		individualLoanProposalGet,
	);
}

export function* onSearchMemberLoanProposalResponseReset() {
	yield takeLatest(
		IndividualLoanActionTypes.SEARCH_MEMBER_LOAN_PROPOSAL_RESPONSE_RESET,
		resetSearchMemberLoanProposalResponse,
	);
}
/** ***************** SEARCH MEMBER LOAN PROPOSAL END ***************** */

export function* individualLoanProposalSaga() {
	yield all([
		call(onIndividualLoanLoanProposal),
		call(onIndividualLoanLoanProposalResponseReset),
		call(onUpdateIndividualLoanLoanProposalResponseReset),
		call(onUpdateIndividualLoanLoanProposal),
		call(onSearchMemberLoanProposal),
		call(onSearchMemberLoanProposalResponseReset),
	]);
}
